/**
 * The months an approval does not reflect (Josie Evans, CORRECTIONS, 2026-10-28, R2), as an SFS correction names them:
 * 'YYYY-MM', sorted, no duplicates, at most 24 -- the same rules the server applies (partialMonths). Shared by the
 * Finance dossier's correction form and the UMED board's SFS correction panel, so both name months the same way.
 * Finance reads them: those months show "Correction" and are not counted as collectible.
 */
import React, { useState } from 'react';
import './MonthsNotReflecting.css';

export const MONTH_RE = /^(\d{4})-(0[1-9]|1[0-2])$/;
const MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const monthLabel = (m: string): string => { const hit = MONTH_RE.exec(m); return hit ? `${MONTH_SHORT[Number(hit[2]) - 1]} ${hit[1]}` : m; };
export const MONTHS_MAX = 24;

export default function MonthsNotReflecting({ months, onChange, disabled = false, emptyWords }: {
  months: string[]; onChange: (next: string[]) => void; disabled?: boolean; emptyWords?: string;
}) {
  const [month, setMonth] = useState('');
  const m = month.trim();
  const canAdd = MONTH_RE.test(m) && !months.includes(m) && months.length < MONTHS_MAX;
  const add = () => { if (!canAdd) return; onChange([...months, m].sort()); setMonth(''); };
  return (
    <div className="um-rowfield" role="group" aria-label="Months not reflecting">
      <span>Months not reflecting (optional)</span>
      <div className="btns cm-months-add">
        <input type="month" value={month} disabled={disabled} onChange={(e) => setMonth(e.target.value)} placeholder="YYYY-MM"
          aria-label="A month that does not reflect (YYYY-MM)" onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }} />
        <button type="button" className="um-open" disabled={disabled || !canAdd} onClick={add}>Add month</button>
      </div>
      {months.length > 0 ? (
        <ul className="um-chips" aria-label="Months named">
          {months.map((x) => (
            <li key={x}>{monthLabel(x)}{' '}
              <button type="button" className="um-link" disabled={disabled} aria-label={`Remove ${monthLabel(x)}`} onClick={() => onChange(months.filter((y) => y !== x))}>Remove</button>
            </li>
          ))}
        </ul>
      ) : <p className="um-quiet">{emptyWords || 'No month named: Finance will read that a correction is open for this approval.'}</p>}
    </div>
  );
}
